import React from 'react'
import LineChartWithLimits from '../../Chart/LineChartWithLimits'
import ZCard from "../../Card/Index";
import { Col, Row, Table } from "antd";
import { ODCCUtilizationData } from '../../../utils/JsonData/OD_CC 1';
import { CURRENCY } from '../../../utils/ConstantData';
import { CurrencyFormatWithDecimal } from '../../../helper/CurrencyFormate';
import CustomAmountText from '../../common/CustomAmountText';

const ODCCUtilizationPage = ({odcc}) => {
  return (
    <div>
      <Row gutter={[24, 24]} className="pt-8">
        <Col className='w-100' span={24} >
            <ZCard>
             <LineChartWithLimits utilizationData={odcc?.utilization || []} />
            </ZCard>
        </Col>
      </Row>
      <Row gutter={[24, 24]} className="pt-8">
        <Col className='w-100' span={24} >
            <ZCard>
             <UtilizationTable utilizationData={odcc?.utilization} />
            </ZCard>
        </Col>
      </Row>
    </div>
    
  )
}


const UtilizationTable = ({ utilizationData=[] }) => {

  const utilizationColumns = [
      {
          title: 'Mode',
          dataIndex: 'mode',
          key: 'mode',
          width: 50
      },
      {
          title: `Sanctioned Limit (${CURRENCY})`,
          dataIndex: 'sanctionedLimit',
          key: 'sanctionedLimit',
          width: 300,
          render: (text, record) => <CustomAmountText value={record.sanctionedLimit} />,
      },
      {
          title: 'Overdrawn Days',
          dataIndex: 'overdrawnDays',
          key: 'overdrawnDays',
          width: 300
      },
      {
        title: 'Average Utilization',
        dataIndex: 'avgUtilization',
        key: 'avgUtilization',
        render: (text, record) => <CustomAmountText value={record.avgUtilization} />,
        width: 300
      },
      {
        title: 'Average Utilization %',
        dataIndex: 'avgUtilizationPct',
        key: 'avgUtilizationPct',
        width: 380
      },
      {
        title: `Max Utilization (${CURRENCY})`,
        dataIndex: 'maxUtilization',
        key: 'maxUtilization',
        render: (text, record) => <CustomAmountText value={record.maxUtilization} />,
        width: 300
      },
      {
          title: 'Max Utilization %',
          dataIndex: 'maxUtilizationPct',
          key: 'maxUtilizationPct',
          width: 300
      },
      {
          title: 'Exceeded Days',
          dataIndex: 'exceededDays',
          key: 'exceededDays',
          width: 300
      },
      // {
        //     title: 'End Date',
      //     dataIndex: 'endDate',
      //     key: 'endDate',
      //     width: 180
      // },
  ];

  return (

            <Table
                columns={utilizationColumns}
                dataSource={utilizationData}
                rowKey={(record) => `${record.sanctionedLimit}-${record.startDate}`}
                pagination={false}
            />
  );
};



export default ODCCUtilizationPage